module.exports = __webpack_public_path__ + "img/savner-du01.5f1cf013.jpeg";